var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgRecordingStop = function SvgRecordingStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 403 393"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    stroke: "#515151",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    cx: 201.5,
    cy: 196.5,
    r: 181
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D11111",
    d: "M302.65 266.977c0 10.51-8.603 19.113-19.115 19.113H119.461c-10.51 0-19.111-8.604-19.111-19.113V126.025c0-10.513 8.6-19.115 19.111-19.115h164.074c10.512 0 19.115 8.603 19.115 19.115v140.952z"
  })));
};

export default SvgRecordingStop;